// extracted by mini-css-extract-plugin
export default {"longModal":"CustomModal_longModal__z0TYF"};